
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/others-pages/legacyandpolicymobile",
      function () {
        return require("private-next-pages/others-pages/legacyandpolicymobile.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/others-pages/legacyandpolicymobile"])
      });
    }
  